import { pickGenericEnemyCard } from './generic';
import type { EnemyAiDecision, EnemyAiDecisionContext } from './types';

export function pickDreadbrandCard(context: EnemyAiDecisionContext): EnemyAiDecision {
  return pickGenericEnemyCard(context);
}
